import { useStorageService } from '~/composables/services/useStorageService';
import { useGameService } from '~/composables/services/useGameService';
import { globalKeys } from '~/assets/data/global-keys';
import type { IGameCategory } from '~/interfaces/dto/games/response';
import type { IRestoreData } from '~/interfaces/dto/general/toast-messages';
import type { RouteLocationAsPathGeneric } from 'vue-router';

interface ILastGame {
  alias: string;
  vertical: string;
  tileImage: string;
}

export default async (userId: string) => {
  const siteStore = useSiteStore();
  const route = useRoute();
  const $storageService = useStorageService();
  const $gameService = useGameService();
  const { $t } = useNuxtApp();

  const gameAvailable = ref<boolean>(false);
  const restoreData = ref<IRestoreData>();
  const game = ref<IGameCategory>();

  const hasShown = $storageService.getSessionStorage({
    key: globalKeys.navigationKeys.hasRestoredSession(userId),
  });

  if (Boolean(hasShown) || !userId || !!route?.params?.game) return;

  const lastGame = $storageService?.getCookie<ILastGame>({
    key: globalKeys.navigationKeys.lastGame(userId),
  });

  const lastRoute = $storageService.getCookie<string>({
    key: globalKeys.navigationKeys.lastRoute(userId),
  });

  gameAvailable.value = Boolean(lastGame);

  if (gameAvailable.value) {
    game.value = await $gameService.fetchGameByAlias({
      alias: lastGame.alias,
      vertical: lastGame.vertical,
      channel: 'webdesktop',
      count: 1,
      languageCode: 'en-US',
      currency: 'USD',
    });
  }

  if (!!game.value)
    restoreData.value = {
      game: game.value,
      restoreUrl: useLaunchGameUrl({ game: game.value, restore: true })
        .url as RouteLocationAsPathGeneric,
    };
  else restoreData.value = { restoreUrl: Boolean(lastRoute) ? lastRoute : '/' };
  if (
    !!restoreData.value?.restoreUrl &&
    restoreData.value?.restoreUrl !== '/'
  ) {
    siteStore.toggleSiteNotice({
      severity: 'restore',
      heading: $t(`restore-${gameAvailable.value ? 'game' : 'session'}`),
      content: {
        type: 'restore-session',
        data: restoreData.value,
      },
      timeout: 7500,
      enabled: true,
    });
  }
};
